import React, { useContext } from "react";
import intl from "react-intl-universal";
import { mdiCalculator, mdiClose } from "@mdi/js";
import styled from "styled-components";

import antennaRest from "../../../rest/antennaRest";
import commonUtils from "../../../script/utils/commonUtils";

import { Grid } from "../../components/Grid";
import { useInput } from "../../hooks/useInput";
import { Button } from "../../components/Button";
import { Spacer } from "../../components/Spacer";
import { Dialog } from "../../containers/Dialog";
import { InputText } from "../../components/InputText";
import { InputNumber } from "../../components/InputNumber";
import { DialogBody } from "../../containers/DialogBody";
import { useValidation } from "../../hooks/useValidation";
import { DialogFooter } from "../../containers/DialogFooter";
import { SelectSingle } from "../../components/SelectSingle";
import { ValidationContext } from "../../contexts/ValidationContext";

const DialogBodyStyle = styled.div`
    height: 100%;
    min-height: 300px;
`;

export const VirtualAntennaDialog = props => {
    const antenna = props?.antenna ?? {};

    const validationContext = useContext(ValidationContext);

    const antennaName = useInput("antennaName", antenna.name);
    const antennaManufacturer = useInput("antennaManufacturer", antenna.manufacturer);
    const apertureHeight = useInput("apertureHeight", antenna.apertureHeight);

    useValidation(value => !commonUtils.isBlank(value), [antennaName]);
    useValidation(value => !commonUtils.isBlank(value), [antennaManufacturer]);
    useValidation(value => !commonUtils.isBlank(value), [apertureHeight]);

    const onCreateVirtualAntenna = async () => {
        const allValid = await validationContext.allValid();
        validationContext.setErrorsVisible(true);
        if (allValid) {
            const newAntenna = {
                name: antennaName.value,
                manufacturer: antennaManufacturer.value,
                apertureHeight: apertureHeight.value,
                originType: "V",
                virtual: true,
            };
            antennaRest.insert(newAntenna);
        }
    };

    return (
        <Dialog
            width="360px"
            title={intl.get("worstcaseData.createVirtualAntenna")}
            onClose={() => props.onClose()}>
            <DialogBody>
                <DialogBodyStyle>
                    <Grid columns="1">
                        <InputText {...antennaName.bind}
                            maxLength="50"
                            title={intl.get("antennas.name")} />
                        <Spacer variant="vertical" />
                        <InputNumber {...apertureHeight.bind}
                            fractionDigits={3}
                            title={intl.get("antennas.apertureHeight")} />
                        <Spacer variant="vertical" />
                        <SelectSingle {...antennaManufacturer.bind}
                            title={intl.get("antennas.manufacturer")}>
                            {(async () => {
                                const manufacturers = await antennaRest.getManufacturers();
                                return manufacturers.map(manufacturer =>
                                    <option key={manufacturer} value={manufacturer}>{manufacturer}</option>
                                );
                            })}
                        </SelectSingle>
                    </Grid>
                </DialogBodyStyle>
            </DialogBody>
            <DialogFooter>
                <Button
                    svgIcon={mdiClose}
                    onClick={() => props.onClose()}
                    value={intl.get("common.cancel")} />
                <Spacer variant="vertical" />
                <Button
                    svgIcon={mdiCalculator}
                    onClick={() => onCreateVirtualAntenna()}
                    value={intl.get("common.create")} />
            </DialogFooter>
        </Dialog>
    );
};